<template>
  <div class="panel billing-unavailable">
    <v-icon
      color="warning"
      class="mr-3">
      mdi-information-outline
    </v-icon>
    L'adresse du service de facturation n'est pas encore configurée pour l'environnement {{ $env.label }}
    (src/environments.js).
  </div>
</template>

<script>
  export default {
    name: 'BillingUnavailable'
  }
</script>

<style scoped>
  .billing-unavailable {
    display: flex;
    align-items: center;
    padding: 20px;
    color: #52525b;
  }
</style>
